import { createContext, useContext } from 'react';

// Shared by every workspace tab: { courseEnrollmentId, student, currentStage, progressByStage, headerReady, refresh }.
// `student` is the /retention/:id/header response, or the CRO Leads row the workspace was opened
// from while that endpoint is not built (same field names as getAllCRMLeadsUpdated).
export const RetentionContext = createContext(null);

export const useRetention = () => {
  const ctx = useContext(RetentionContext);
  if (!ctx) throw new Error('useRetention must be used inside RetentionLayout');
  return ctx;
};
